module.exports = __webpack_public_path__ + "img/insta4.6d187e67.jpg";